import createIcon from '../../createIcon';

/**
 * @component @name SocialDistance
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA1QzQgMy45IDQuOSAzIDYgM0M3LjEgMyA4IDMuOSA4IDVDOCA2LjEgNy4xIDcgNiA3QzQuOSA3IDQgNi4xIDQgNVpNOC43OCA4LjU4QzcuOTMgOC4yMSA2Ljk5IDggNiA4QzUuMDEgOCA0LjA3IDguMjEgMy4yMiA4LjU4QzIuNDggOC45IDIgOS42MiAyIDEwLjQzVjExSDEwVjEwLjQzQzEwIDkuNjIgOS41MiA4LjkgOC43OCA4LjU4Wk0xOCA3QzE5LjEgNyAyMCA2LjEgMjAgNUMyMCAzLjkgMTkuMSAzIDE4IDNDMTYuOSAzIDE2IDMuOSAxNiA1QzE2IDYuMSAxNi45IDcgMTggN1pNMjAuNzggOC41OEMxOS45MyA4LjIxIDE4Ljk5IDggMTggOEMxNy4wMSA4IDE2LjA3IDguMjEgMTUuMjIgOC41OEMxNC40OCA4LjkgMTQgOS42MiAxNCAxMC40M1YxMUgyMlYxMC40M0MyMiA5LjYyIDIxLjUyIDguOSAyMC43OCA4LjU4Wk0yMiAxN0wxOCAxM1YxNkg2VjEzTDIgMTdMNiAyMVYxOEgxOFYyMUwyMiAxN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SocialDistance = createIcon('SocialDistance', [
  [
    'path',
    {
      d: 'M4 5C4 3.9 4.9 3 6 3C7.1 3 8 3.9 8 5C8 6.1 7.1 7 6 7C4.9 7 4 6.1 4 5ZM8.78 8.58C7.93 8.21 6.99 8 6 8C5.01 8 4.07 8.21 3.22 8.58C2.48 8.9 2 9.62 2 10.43V11H10V10.43C10 9.62 9.52 8.9 8.78 8.58ZM18 7C19.1 7 20 6.1 20 5C20 3.9 19.1 3 18 3C16.9 3 16 3.9 16 5C16 6.1 16.9 7 18 7ZM20.78 8.58C19.93 8.21 18.99 8 18 8C17.01 8 16.07 8.21 15.22 8.58C14.48 8.9 14 9.62 14 10.43V11H22V10.43C22 9.62 21.52 8.9 20.78 8.58ZM22 17L18 13V16H6V13L2 17L6 21V18H18V21L22 17Z',
      key: '7r6n6i',
    },
  ],
]);

export default SocialDistance;
